/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostAuthSendPasswordResetEmailRequest
 */
export interface PostAuthSendPasswordResetEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof PostAuthSendPasswordResetEmailRequest
     */
    email: string;
}

/**
 * Check if a given object implements the PostAuthSendPasswordResetEmailRequest interface.
 */
export function instanceOfPostAuthSendPasswordResetEmailRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function PostAuthSendPasswordResetEmailRequestFromJSON(json: any): PostAuthSendPasswordResetEmailRequest {
    return PostAuthSendPasswordResetEmailRequestFromJSONTyped(json, false);
}

export function PostAuthSendPasswordResetEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAuthSendPasswordResetEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function PostAuthSendPasswordResetEmailRequestToJSON(value?: PostAuthSendPasswordResetEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

